import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { QuestionaireItem } from 'src/app/models';
import { DynamicComponent } from 'src/app/components/base/dynamic.component';
import { PluginService } from 'src/app/services';

@Component({
    selector: 'questionaire-item-component',
    templateUrl: 'questionaire.item.component.html'
})
export class QuestionaireSectionItemComponent extends DynamicComponent implements OnInit {

    constructor(public pluginService: PluginService) {
        super(pluginService);
    }
    question_types:any = [];

    @Input() item: QuestionaireItem;

    @Output() delete = new EventEmitter();

    ngOnInit() {
      this.question_types = ['TextBox', 'CheckBox','SelectBox'];
    }
}
